import { createSelector } from '@ngrx/store';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';

export const cmmsManagementState = state => state.cmms.cmmsState;

export const activePage = createSelector(cmmsManagementState, cmms => cmms.activePage);

export const cmmsStatuses = (page: CmmsPages) =>
	createSelector(cmmsManagementState, cmms => {
		if (!cmms.statuses[page]) {
			return [];
		}

		return cmms.statuses[page];
	});

export const cmmsClassifications = createSelector(
	cmmsManagementState,
	cmms => cmms.classifications
);

export const cmmsLayoutOptions = createSelector(
	cmmsManagementState,
	cmms => cmms.layoutOptions
);

export const cmmsSelectedLayoutType = createSelector(
	cmmsManagementState,
	cmms => cmms.selectedLayoutType
);

export const isCalendarLayoutActive = createSelector(
	cmmsManagementState,
	cmms =>
		cmms.selectedLayoutType === 'calendar' &&
		[CmmsPages.wo, CmmsPages.incidents].includes(cmms.activePage)
);

export const cmmsNsFieldsKeyValues = createSelector(
	cmmsManagementState,
	cmms => cmms.nsFieldsData.nsFieldsKeyValues
);
export const nameNsFieldsDescriptionList = createSelector(
	cmmsManagementState,
	cmms => cmms.nsFieldsData.nameDescriptionList
);
